import * as React from 'react';

import _ from 'lodash';

import NotificationContainer from 'bundles/program-home/components/enterprise-home/NotificationContainer';
import type { EnterpriseHomePageQuery_EnterpriseLearnerSummariesV1Resource_byUserIdAndThirdPartyOrgSlug_elements_invitations_elements as ProgramInvitation } from 'bundles/program-home/components/enterprise-home/__generated__/EnterpriseHomePageQuery';
import PendingInvitationBanner from 'bundles/program-home/components/multiprogram/PendingInvitationBanner';

type PropsFromCaller = {
  programInvitations: ProgramInvitation[];
};

const styles = {
  banner: {
    marginBottom: 18,
  },
};

const PendingInvitations = ({ programInvitations }: PropsFromCaller) => {
  const invitations = programInvitations.filter(
    (x) => Boolean(x.userRoster?.program?.metadata.slug) && Boolean(x.userRoster?.program?.metadata.name)
  );
  const invitationsOrderedByDateDescending = _.orderBy(invitations, 'createdAt', 'desc');
  const notifications = invitationsOrderedByDateDescending.map((x) => (
    <PendingInvitationBanner
      key={x.id}
      style={styles.banner}
      // See above filter.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      programSlug={x.userRoster!.program!.metadata.slug}
      // See above filter.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      programName={x.userRoster!.program!.metadata.name}
    />
  ));

  return <NotificationContainer notificationsToShow={2}>{notifications}</NotificationContainer>;
};

export default PendingInvitations;
